import { render, staticRenderFns } from "./subMasterCopySettingForm.vue?vue&type=template&id=1cfc6d6d&scoped=true"
import script from "./subMasterCopySettingForm.vue?vue&type=script&lang=js"
export * from "./subMasterCopySettingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc6d6d",
  null
  
)

export default component.exports